<template>
    <div id="contenedor-main-listado-reporte-ejecutivo">
      <template
        v-if="tipo === 1">
        <card
          :listado="listado"
          :imprimir="imprimir">
        </card>
      </template>
      <template
        v-else>
        <listado
          :listado="listado"
          :imprimir="imprimir">
        </listado>
      </template>
    </div>
</template>

<script>
import Card from './Card.vue';
import Listado from './Listado.vue';

export default {
  name: 'MainListadoReporteEjecutivo',
  components: {
    Card,
    Listado,
  },
  props: {
    tipo: {
      type: Number,
      required: true,
    },
    listado: {
      type: Array,
      required: true,
    },
    imprimir: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
